module.exports = __webpack_public_path__ + "img/students-full-sm.ea71c3be.jpg";